import * as React from 'react';
import { FC, CSSProperties } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: CSSProperties;
}

const Pause: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    fill={color} 
    style={style}
  >
    <g>
      <path d="M39.22,24.25h-2.57c-2.99,0-5.42,2.43-5.42,5.42v40.65c0,2.99,2.43,5.42,5.42,5.42h2.57c2.99,0,5.42-2.43,5.42-5.42V29.68   C44.64,26.69,42.21,24.25,39.22,24.25z"/>
      <path d="M63.36,24.25h-2.57c-2.99,0-5.42,2.43-5.42,5.42v40.65c0,2.99,2.43,5.42,5.42,5.42h2.57c2.99,0,5.42-2.43,5.42-5.42V29.68   C68.78,26.69,66.35,24.25,63.36,24.25z"/>
    </g>
  </svg>
);

export default Pause;